var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgDarkMode = function SvgDarkMode(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.53535 2.49523C8.60401 2.61407 8.59687 2.76207 8.5171 2.87375C7.27783 4.60873 7.40719 7.08358 8.94645 8.62283C10.1768 9.85314 11.9692 10.1684 13.5256 9.6703C13.6554 9.62877 13.7975 9.66634 13.8898 9.7666C13.9821 9.86685 14.0078 10.0116 13.9557 10.1375C13.1047 12.1942 11.0485 13.687 8.69896 13.687C5.57232 13.687 3.01562 11.1303 3.01562 8.00365C3.01562 5.01878 5.29044 2.60567 8.19831 2.32197C8.33491 2.30865 8.46669 2.37639 8.53535 2.49523ZM7.53953 3.14272C5.34007 3.68395 3.71562 5.642 3.71562 8.00365C3.71562 10.7437 5.95892 12.987 8.69896 12.987C10.4943 12.987 12.1056 11.9849 12.9815 10.5206C11.3965 10.7866 9.68773 10.3541 8.45147 9.11781C6.85134 7.51768 6.56914 5.07084 7.53953 3.14272Z",
    fill: "#B3B3B3"
  }))));
};
export default SvgDarkMode;